<template>
  <span style="word-break: break-word">
    <template v-if="event">
      <router-link
        v-if="!disableLink"
        :to="linkToEvent"
        class="no-default-link-style"
        :target="targetLink"
      >
        {{ displayEvent.name }}
      </router-link>
      <span v-else>
        {{ displayEvent.name }}
      </span>
    </template>
    <template v-else> Missing event id! </template>
  </span>
</template>
<script>
import gql from "fraql";
export default {
  name: "AppShowEventName",
  props: {
    event: {
      type: [Object, String],
      required: true
    },
    disableLink: {
      type: Boolean,
      default: false
    },
    targetLink: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      queriedEvent: null
    };
  },
  computed: {
    displayEvent() {
      if (typeof this.event === "string" || this.event instanceof String) {
        return this.queriedEvent || { id: this.event };
      } else {
        return this.event;
      }
    },
    linkToEvent() {
      if (this.displayEvent.noncompetition) {
        return {
          name: "NoncompetitionEventProfilePage",
          params: { eventId: this.displayEvent.id }
        };
      }
      if (
        ["results_published", "closed", "archived"].includes(
          this.displayEvent.status
        )
      ) {
        return {
          name: "EventResultsPage",
          params: { eventId: this.displayEvent.id }
        };
      } else {
        return {
          name: "EventProfilePage",
          params: { eventId: this.displayEvent.id }
        };
      }
    }
  },
  fragments: {
    event: gql`
      fragment _ on Event {
        id
        name
        status
        noncompetition
        disciplineId
        discipline @client {
          id
          name
        }
      }
    `
  },
  apollo: {
    queriedEvent: {
      query: gql`
        query showEventName($id: ID) {
          event(id: $id) {
            id
            name
            status
            noncompetition
            disciplineId
            discipline @client {
              id
              name
            }
          }
        }
      `,
      variables() {
        return {
          id: this.event
        };
      },
      skip() {
        return !(
          typeof this.event === "string" || this.event instanceof String
        );
      }
    }
  }
};
</script>
